import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import DemoLogin from "@client.components/DemoLogin";
import Icon from "@client.components/Icon";
import Loader from "@client.components/Loader";
import ErrorMessage from "@client.components/ErrorMessage";
import {
  makeLoginError,
  makeLoginLoading,
} from "@client.pages/Login/reducer";
import "@client.pages/Login/Login.scss";

const Demo = () => {
  const loginError = useSelector(makeLoginError);
  const loginLoading = useSelector(makeLoginLoading);
  const { t } = useTranslation();

  return (
    <div className="login">
      <ErrorMessage template="pages.Login.failedLogin" message={loginError} />
      <div className="login-container">
        <Icon name="logo-main" className="logo" isSvg={true} />
        <div className="btns">
          {loginLoading && <Loader loading={true} />}
          {loginLoading && (
            <span className="sync-loading">
              {t("pages.Login.syncCalendarEvents")}
            </span>
          )}
          <DemoLogin hide={loginLoading} />
        </div>
      </div>
    </div>
  );
};

export default Demo;
